module.exports = __webpack_public_path__ + "img/mesa_el_c.18c15a0c.png";